import type { ToastT } from 'sonner'

export type ToastAction = { label: string; href: string }

export type BusProps = {
  message: string
  request_id?: string
  details?: { message: string }[]
  actions?: ToastAction[]
  type?: ToastT['type']
  duration?: number
  closeButton?: boolean
  icon?: React.ReactNode
  action?: { label: React.ReactNode; onClick: () => void }
}

export const shortBusProps: Partial<BusProps> = {
  duration: 2000,
  type: 'default',
}
export const downloadBusProps: Partial<BusProps> = {
  duration: 5000,
  type: 'info',
}

export const successBusProps: Partial<BusProps> = {
  duration: 2000,
  type: 'success',
}

export const warningBusProps: Partial<BusProps> = {
  duration: 6000,
  type: 'warning',
}

export const errorBusProps: Partial<BusProps> = {
  duration: 5000,
  type: 'error',
}

/*
  Custom Event Bus for toast messages
  
  Example usage:
  emitToast({
    message: 'Error message',
    request_id: '1234567890',
    details: [{ message: 'Detail message' }],
    type: 'error',
  })
*/
const toastInfoBus = new EventTarget()

/*
  emitToast function used for: 
  - show toast message 
  
  Example:
  emitToast({
    message: 'Error message',
    request_id: '1234567890', // "optional" request id, used for error tracking
    details: [{ message: 'Detail message' }], // optional additional details
    type: 'error', // 'success', 'info', 'error', 'warning'
  })
*/
export function emitToast(props: BusProps) {
  toastInfoBus.dispatchEvent(new CustomEvent<BusProps>('toastInfo', { detail: props }))
}

export function subscribeEmitToast(handler: (props: BusProps) => void): () => void {
  const listener = (event: Event) => {
    const props = event as CustomEvent<BusProps>
    handler(props.detail)
  }
  toastInfoBus.addEventListener('toastInfo', listener)

  return () => toastInfoBus.removeEventListener('toastInfo', listener)
}
